import { RateTableCarrier } from "@redotech/redo-fulfillment-outbound-labels-common/rate-table-carrier";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const acceptLabelsUpsell = {
  name: "acceptLabelsUpsell" as const,
  input: z.object({
    annualRedoProfit: z.number(),
    carrier: createEnum(RateTableCarrier, { enumName: "RateTableCarrier" }),
  }),
  output: z.object({ success: z.boolean() }),
};
